import { render, staticRenderFns } from "./UiContentMenu.vue?vue&type=template&id=f475217a"
import script from "./UiContentMenu.vue?vue&type=script&lang=ts"
export * from "./UiContentMenu.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports